import { Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./components/common/Layout";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import PageNotFound from "./pages/PageNotFound";
import PolicyPage from "./pages/PolicyPage";
import CodeOfConduct from "./pages/CodeOfConduct";
import DisclaimerPage from "./pages/DisclaimerPage";

function App() {
  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
